import { ActivatedRouteSnapshot, BaseRouteReuseStrategy } from '@angular/router';
import { PlanningOverviewComponent } from './pages/planning-overview/planning-overview.component';

// asfaltplanning, asfaltplanning/:date and asfaltplanning/:date/:planningId are separate routes; reuse the
// component so changing the date in the URL doesn't recreate the screen
export class PlanningOverviewRouteReuseStrategy extends BaseRouteReuseStrategy {
    override shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
        return (
            super.shouldReuseRoute(future, curr) ||
            (future.component === PlanningOverviewComponent && curr.component === PlanningOverviewComponent)
        );
    }
}
